// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"66f45d18","454":"20e8798e"}[chunkId] + ".chunk.css";
};